import { render, staticRenderFns } from "./path_home.vue?vue&type=template&id=3445753e&"
import script from "./path_home.vue?vue&type=script&lang=js&"
export * from "./path_home.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports